import { useTranslation } from "react-i18next"
import { Button } from "../../components"
import { OperatorSelectTable } from "./OperatorSelectTable"

const T_PREFIX = 'cycle_counts.bulk_assign.operator_step'

export const BulkAssignOperatorStep = ({
    assignableCount,
    selectedOperators = [],
    onOperatorsChange,
    onNext,
    onBack,
    busy,
    warehouseId,
    role,
}) => {
    const { i18n } = useTranslation()

    return (
        <div>
            <h3 className="text-lg font-medium text-gray-900 mb-4 text-center">
                {i18n.t(`${T_PREFIX}.title`, { count: assignableCount })}
            </h3>

            <OperatorSelectTable
                selectionType="checkbox"
                selectedOperators={selectedOperators}
                onOperatorsChange={onOperatorsChange}
                warehouseId={warehouseId}
                role={role}
            />

            <div className="mt-3 flex justify-between">
                <Button type="secondary" onClick={onBack}>
                    {i18n.t(`${T_PREFIX}.back`)}
                </Button>
                <Button
                    type="primary"
                    disabled={selectedOperators.length === 0 || busy}
                    onClick={() => onNext(selectedOperators)}
                    loading={busy}
                >
                    {i18n.t(`${T_PREFIX}.assign_button`)}
                </Button>
            </div>
        </div>
    )
}
